import { GetContextMenuItemsParams, MenuItemDef } from 'ag-grid-enterprise';
import {
  endpointFundDocumentPATCH,
  FundDocument,
} from '~/api/def/endpoints/fundEndpoint';
import {
  endpointFundDocumentDELETE,
  endpointRunFundDocumentExtractionPOST,
} from '~/api/def/endpoints/document/documentExtractionEndpoint';

export const getDocumentsContextMenu = (
  params: GetContextMenuItemsParams<FundDocument>,
  callbacks: {
    showDocumentOverview: (documentId: string) => void;
    loadDocuments: (fundId: string) => void;
  },
): (string | MenuItemDef)[] => {
  console.log('params', params);
  console.log('node', params.node);
  const result: (string | MenuItemDef)[] = [
    {
      name: 'Document Overview',
      action: async () => {
        if (params?.node?.data?.id)
          await callbacks?.showDocumentOverview(params.node.data.id);
      },
      disabled:
        !params?.node?.data?.id ||
        params?.node?.data?.extractionStatus === 'started',
      cssClasses: ['red', 'bold'],
    },
    {
      name: 'Rerun Document Extraction',
      action: async () => {
        if (params?.node?.data?.id) {
          await endpointRunFundDocumentExtractionPOST(params.node.data.id);
          callbacks?.loadDocuments(params.node.data.fundId);
        }
      },
      disabled:
        !params?.node?.data?.id ||
        params?.node?.data?.extractionStatus === 'started',
      cssClasses: ['red', 'bold'],
    },
    {
      // name: "Toggle Document Liveness",
      name: 'Send to archive',
      action: async () => {
        if (params?.node?.data?.id) {
          await endpointFundDocumentPATCH(
            params.node.data.fundId,
            params.node.data.id,
            { liveness: false },
          );
          callbacks?.loadDocuments(params.node.data.fundId);
        }
      },
      disabled:
        !params?.node?.data?.id ||
        params?.node?.data?.extractionStatus === 'started',
      cssClasses: ['red', 'bold'],
    },
    {
      name: `${params?.node?.data?.restated ? 'Unset restated' : 'Restate Agreement'}`,
      action: async () => {
        if (params?.node?.data?.id) {
          const response = await endpointFundDocumentPATCH(
            params.node.data.fundId,
            params.node.data.id,
            { restated: !params?.node?.data?.restated },
          );
          if (response?.success) {
            callbacks?.loadDocuments(params.node.data.fundId);
          }
        }
      },
      disabled:
        !params?.node?.data?.id ||
        params?.node?.data?.extractionStatus === 'started',
    },
    {
      name: 'Delete document',
      action: async () => {
        if (params?.node?.data?.id) {
          const response = await endpointFundDocumentDELETE(
            params.node.data.id,
          );
          if (response?.success) {
            callbacks?.loadDocuments(params.node.data.fundId);
          }
        }
      },
    },
    'separator',
    'paste',
    'copy',
    'separator',
    'autoSizeAll',
    'excelExport',
    'copyWithHeaders',
    'csvExport',
  ];
  return result;
};
